import Logout from "@mui/icons-material/Logout";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  ListItemIcon,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, Popover } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { removeToken } from "../../redux/tokenSlice";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useForm } from "react-hook-form";
import classnames from "classnames";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Loader";
import axios from "axios";
// import "./../FinanceGrid.css";
// import "../../Assets/CSS/bulkorder.css";
import { NavBar } from "../Navbar/NavBar";

import Sidebar from "../Sidebar";
// import AutofundConfirmation from "./AutofundConfirmation";
import AddProduct1 from "../Finance Grid Operations/AddProduct1";
import AddProduct2 from "../Finance Grid Operations/AddProduct2";
import LendingPartnerScroller from "../scrollingCards";
import { fetchData } from "../../services/api.service";
import { IconButton, InputAdornment } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SendIcon from "@mui/icons-material/Send";
import { modalStyle } from "../../constant";
import { restrictedUser } from "../../utils";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  borderTop: "7px solid #99243D",
  p: 2,
};

function AyekartAgroFNVOrders() {
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [businessCategory, setBusinessCategory] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [options, setOptions] = useState();
  const [partner1, setPartner1] = useState();
  const [product1, setProduct1] = useState();
  const [product1Name, setProduct1Name] = useState();
  const [partner2, setPartner2] = useState();
  const [product2, setProduct2] = useState();
  const [openProduct1, setOpenProduct1] = useState(false);
  const closehandleProduct1 = () => setOpenProduct1(false);
  const [openProduct2, setOpenProduct2] = useState(false);
  const closehandleProduct2 = () => setOpenProduct2(false);
  const [singleData, setSingleData] = useState();
  const [product2Name, setProduct2Name] = useState();
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const history = useNavigate();
  const [loadingData, setLoadingData] = useState([]);
  const [lendingPartnersCardsData, setLendingPartnerCardsData] = useState();
  const [autoFundModel, setAutoFundModel] = useState(false);
  const autoFundCloseHandler = () => setAutoFundModel(false);
  const autoFundOpenHandler = () => setAutoFundModel(true);
  const [autoFund, setAutoFund] = useState();
  const [gridComment, setGridComment] = useState("");
  const [transactionTypes, setTransactionTypes] = useState("");
  const [supplierTransactionTypes, setSupplierTransactionTypes] = useState("");
  const [workTypes, setWorkTypes] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    AuthService.logout();
    dispatch(removeToken);
    history("/login");
  };
  const id = open ? "simple-popover" : undefined;

  // All users will have access to finance-grid
  // useEffect(() => {
  //   if (userDetails?.user_category !== "Operations") {
  //     toast.error("Access denied");
  //     return history("/bulkorder");
  //   }
  // }, []);

  //---------------Other States ----------------//
  const [dataArray, setDataArray] = useState([]);
  const [sampleData, setSampleData] = useState();
  const [dataArrayTocheck, setDataArrayTocheck] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bulkUploadFile, setBulkUploadFile] = useState(null);
  const [bulkUploadLoading, setBulkUploadLoading] = useState(false);
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(false);
  const [openFailedResponseModal, setOpenFailedResponseModal] = useState(false);
  const [failedResponseList, setFailedResponseList] = useState([]);
  const bulkFileInputRef = useRef(null);
  const dataArrayRef = useRef(dataArray);
  dataArrayRef.current = dataArray;

  const closeBulkUploadModal = () => {
    if (!bulkUploadLoading) {
      setOpenBulkUploadModal(false);
      setBulkUploadFile(null);
      if (bulkFileInputRef.current) bulkFileInputRef.current.value = "";
    }
  };

  const FNV_BULK_GRID_API = "/workflow/api/finance_grids_fnv_purchase_bulk";
  //------------------Other States ends here----//

  //-------------------APIs and Functions----------------//

  // ---------------------------------------Pagination---------------------------//
  const [totalResults, setTotalResults] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsCount = 5;
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(5);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(15);

  useEffect(() => {
    getList();
  }, [page, currentPage]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItem = loadingData?.results?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage == number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  // ---------------------------------------Pagination---------------------------//

  const handleCheckAndAddOrder = (submitData) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    axios
      .post(
        "/workflow/api/finance_grids_fnv_purchase",
        {
          orders: [submitData?.order_id],
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((data) => {
        if (!data?.data?.status) {
          setLoading(false);
          return toast.error(data?.data?.message);
        }
        let temp = dataArray;
        let tempTocheck = dataArrayTocheck;
        let resultObj = data?.data?.grids[0];
        let checkDuplicates = temp.find(
          (item) => Number(item.order_id) === Number(submitData?.order_id)
        );
        if (checkDuplicates) {
          setLoading(false);
          return toast.error(
            `Order with ID:${submitData?.order_id} has already added`
          );
        }
        temp.push({
          ...resultObj,
          total_payable: resultObj?.total_cp,
          total_payable_net_off_tds: resultObj?.total_cp,
          work_type: resultObj?.work_type,
          transaction_type: resultObj?.transaction_type,
          transaction_type_supplier_payment:
            resultObj?.transaction_type_supplier_payment,
        });
        tempTocheck.push({
          ...resultObj,
          total_payable: resultObj?.total_cp,
          total_payable_net_off_tds: resultObj?.total_cp,
          work_type: resultObj?.work_type,
          transaction_type: resultObj?.transaction_type,
          transaction_type_supplier_payment:
            resultObj?.transaction_type_supplier_payment,
        });

        setDataArray(temp);
        setDataArrayTocheck(tempTocheck);
        setLoading(false);
        toast.success("Order has been added successfully in Grid Table");
        reset({
          order_id: "",
        });
      });
  };

  const handleCheckAndAddOrderFromTable = (orderID) => {
    let size = dataArray.length;

    if (dataArray?.length > 0) {
      if (
        dataArray[size - 1]?.first_partner &&
        dataArray[size - 1]?.first_partner_amount !== "0" &&
        dataArray[size - 1]?.first_partner_amount !== null
      ) {
        setLoading(true);
        const token = localStorage.getItem("token");
        axios
          .post(
            "/workflow/api/finance_grids_fnv_purchase",
            {
              orders: [orderID],
            },
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then((data) => {
            if (data?.data?.status === false) {
              setLoading(false);
              toast.error(data?.data?.message);
            }
            let temp = dataArray;
            let tempTocheck = dataArrayTocheck;
            let resultObj = data?.data?.grids[0] && data?.data?.grids[0];

            let checkDuplicates = temp?.find(
              (item) => Number(item?.order_id) === Number(orderID)
            );
            if (checkDuplicates) {
              setLoading(false);

              return toast.error(`Order with ID:${orderID} has already added`);
            }
            temp.push({
              ...resultObj,
              total_payable: resultObj?.total_cp,
              total_payable_net_off_tds: resultObj?.total_cp,
              work_type: resultObj?.work_type,
              transaction_type: resultObj?.transaction_type,
              transaction_type_supplier_payment:
                resultObj?.transaction_type_supplier_payment,
            });
            tempTocheck.push({
              ...resultObj,
              total_payable: resultObj?.total_cp,
              total_payable_net_off_tds: resultObj?.total_cp,
              work_type: resultObj?.work_type,
              transaction_type: resultObj?.transaction_type,
              transaction_type_supplier_payment:
                resultObj?.transaction_type_supplier_payment,
            });
            setPartner1(resultObj?.first_partner);
            setPartner2(resultObj?.second_partner);
            setDataArray(temp);
            setDataArrayTocheck(tempTocheck);
            setLoading(false);

            toast.success("Order has been added successfully in Grid Table");
            reset({
              order_id: "",
            });
          });
      } else {
        if (dataArray[size - 1]?.first_partner === null) {
          toast.error(
            `Please add Lending partner 1 for ${dataArray[size - 1]?.order_id}`
          );
        } else {
          toast.error(
            `Please add Lending partner 1 amount for ${
              dataArray[size - 1]?.order_id
            }`
          );
        }
        if (
          dataArray[size - 1]?.total_cp < dataArray[size - 1]?.total_payable
        ) {
          toast.error(
            "Please total payable should not be greate then total cp"
          );
        }
      }
    } else {
      setLoading(true);
      const token = localStorage.getItem("token");
      axios
        .post(
          "/workflow/api/finance_grids_fnv_purchase",
          {
            orders: [orderID],
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((data) => {
          if (!data?.data?.status) {
            setLoading(false);
            return toast.error(data?.data?.message);
          }
          let temp = dataArray;
          let tempTocheck = dataArrayTocheck;
          let resultObj = data?.data && data?.data?.grids[0];

          let checkDuplicates = temp?.find(
            (item) => Number(item?.order_id) === Number(orderID)
          );
          if (checkDuplicates) {
            setLoading(false);
            return toast.error(`Order with ID:${orderID} has already added`);
          }
          temp.push({
            ...resultObj,
            total_payable: resultObj?.total_cp,
            total_payable_net_off_tds: resultObj?.total_cp,
            work_type: resultObj?.work_type,
            transaction_type: resultObj?.transaction_type,
            transaction_type_supplier_payment:
              resultObj?.transaction_type_supplier_payment,
          });
          tempTocheck.push({
            ...resultObj,
            total_payable: resultObj?.total_cp,
            total_payable_net_off_tds: resultObj?.total_cp,
            work_type: resultObj?.work_type,
            transaction_type: resultObj?.transaction_type,
            transaction_type_supplier_payment:
              resultObj?.transaction_type_supplier_payment,
          });
          setPartner1(resultObj?.first_partner);
          setPartner2(resultObj?.second_partner);
          setDataArray(temp);
          setDataArrayTocheck(tempTocheck);
          setLoading(false);

          toast.success("Order has been added successfully in Grid Table");
          reset({
            order_id: "",
          });
        });
    }
  };

  const onchangeForTDS = (e, elem, indx) => {
    let temp = dataArray;
    let a = temp?.map((ele, eleIndex) => {
      if (eleIndex === indx) {
        let tdsValue = isNaN(e.target.value) ? 0 : e.target.value;
        console.log(Number(elem?.total_payable) - Number(tdsValue));
        let isRes = Number(elem?.total_payable) - Number(tdsValue);
        return {
          ...ele,
          tds: Number(tdsValue),
          amount_to_be_paid_net_off_tds: isRes,
        };
      } else {
        return ele;
      }
    });
    console.log(a, "----------a-----------------");
    setDataArray(a);
  };

  const totalPayableHandler = (e, ele, index) => {
    const updatedArray = dataArray.map((obj) => {
      if (obj.order_id === ele?.order_id) {
        return {
          ...obj,
          total_payable: Number(e.target.value),
          amount_to_be_paid_net_off_tds:
            Number(e.target.value) - Number(ele?.tds),
        };
      }
      return obj;
    });
    console.log(updatedArray);
    setDataArray([...updatedArray]);
    // let temp = dataArray;
    // let a = temp?.map((ele, eleIndex) => {
    //   if (eleIndex === index) {
    //     let totalPayableValue = isNaN(e.target.value) ? 0 : e.target.value;
    //     return {
    //       ...ele,
    //       total_payable: totalPayableValue,
    //     };
    // if (totalPayableValue) {
    //   return {
    //     ...ele,
    //     total_payable_net_off_tds: totalPayableValue,
    //   };
    // } else {
    //   return toast.error(
    //     `Total payable amount is not greater then Total CP`
    //   );
    // }
    // if(totalPayableValue>ele?.total_cp){
    //   return{
    //     ...ele ,total_payable_net_off_tds:0,
    //   }
    //     }
    //   });
    //   setDataArray(a);
  };

  const onChangeHandlerForTotalCp = (e, cpObj, cpIndex) => {
    let tempTocheck = 0;
    dataArrayTocheck?.map((item, index) => {
      if (Number(item?.order_id) === Number(cpObj?.order_id)) {
        tempTocheck = item?.total_cp;
      }
    });
    if (tempTocheck !== 0) {
      if (tempTocheck < Number(e.target.value)) {
        return toast.error("Value must not be greater than Total_CP");
      }
    }
    let temp = dataArray?.map((ele, eleIndex) => {
      if (eleIndex === cpIndex) {
        let tds = 0;
        if (Number(ele?.procurement_gtv) > 5000000) {
          tds =
            0.001 *
            (Number(e.target.value) +
              Number(ele?.procurement_gtv) -
              5000000 -
              Number(ele?.fytd_gst_amount) -
              Number(ele?.tds_fytd));
        } else {
          tds = 0;
        }
        return {
          ...ele,
          total_payable: isNaN(e.target.value) ? "" : e.target.value,
          amount_to_be_paid_net_off_tds:
            Number(e.target.value) - Number(cpObj?.tds),
        };
      } else {
        return ele;
      }
    });
    setDataArray(temp);
  };

  const removeFromDataArray = (index) => {
    let tempArray = dataArray?.filter((item, itemIndex) => index !== itemIndex);
    setDataArray(tempArray);
  };

  const submitGrids = () => {
    const token = localStorage.getItem("token");

    let temp = dataArray?.map((eleToSubmit, eleToSubmitIndex) => {
      return eleToSubmit;
    });
    let newArray = temp?.filter(
      (product) => product.total_payable > product?.total_cp
    );
    let LpArray = temp?.filter(
      (lp) =>
        Number(lp?.first_partner_amount) + Number(lp?.second_partner_amount) >
        lp?.total_cp
    );
    if (
      temp[temp?.length - 1]?.first_partner &&
      temp[temp?.length - 1]?.first_partner_amount !== "0" &&
      temp[temp - 1]?.first_partner_amount !== null &&
      newArray?.length === 0 &&
      LpArray?.length === 0
    ) {
      const requiredFields = [
        "transaction_type",
        "transaction_type_supplier_payment",
        "work_type",
      ];

      const isAnyFieldMissing = temp.some((item) =>
        requiredFields.some(
          (field) => !item[field] || item[field].toString().trim() === ""
        )
      );

      if (isAnyFieldMissing) {
        return toast.error(
          "Please fill all required fields: Transaction Type, Supplier Payment Type, and Work Type."
        );
      }
      setLoading(true);
      axios
        .post(
          "/workflow/api/fnv_purchase_add_grids",
          {
            orders: temp,
            actioner: userDetails?.user_name
              ? userDetails?.user_name
              : userDetails?.user_category,
            is_exceptional: false,
            org_id: 1,
            grid_comments: gridComment,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((data) => {
          if (data?.data?.status === true) {
            setLoading(false);
            toast.success(data?.data?.message);
            setDataArray([]);
            history("/ayekart-agro/fnv/grids");
          } else {
            if (data?.data?.status === false) {
              setLoading(false);
              return toast.error(data?.data?.message);
            } else {
              setLoading(false);
              return toast.error("Something went wrong");
            }
          }
        });
    } else {
      if (temp[temp?.length - 1]?.first_partner === null) {
        toast.error(
          `Please add Lending partner 1 for ${
            temp[temp?.length - 1]?.order_id
          } `
        );
      } else if (temp[temp?.length - 1]?.first_partner_amount === "0") {
        toast.error(
          `Please add Lending partner 1 amount for ${
            temp[temp?.length - 1]?.order_id
          }`
        );
      } else if (newArray?.length > 0) {
        toast.error(
          `total payable should not be greater then total cp for this orders ${newArray?.map(
            (item, index) => item?.order_id
          )} `
        );
      } else if (LpArray?.length > 0) {
        toast.error(
          ` partners amount should not be greater then total cp for this orders ${LpArray?.map(
            (item, index) => item?.order_id
          )} `
        );
      }
    }
  };

  //=================Calculate amount in Indian format====================//
  function amountFormat(x, defaultValue = 0) {
    if (!x) {
      return defaultValue;
    }
    x = x.toString();
    var afterPoint = "";
    if (x?.indexOf(".") > 0)
      afterPoint = x.substring(x?.indexOf("."), x?.length);
    x = Math.floor(x);
    x = x?.toString();
    var lastThree = x?.substring(x?.length - 3);
    var otherNumbers = x?.substring(0, x?.length - 3);
    if (otherNumbers != "") lastThree = "," + lastThree;
    var res =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
    return res;
  }

  const getList = () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    fetch(
      `/workflow/api/orders/fnv_purchase?start=${page * limit - limit}&length=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((data) => {
        if (data?.status === 401) {
          toast.error("Session timeout, Please login again");
          history("/login");
        }
        return data.json();
      })
      .then((data) => {
        // setLoadingData(data?.orders?.rows);
        setLoadingData(data?.orders);
        // setTotalResults(data?.orders?.count);
        setTotalResults(data?.count);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`/api/partners?page=1&limit=1000`)
      .then((response) => {
        const options = response?.data?.partners.rows?.map((item) => {
          const label =
            item?.lending_partner?.toLowerCase()?.indexOf("ayekart") !== -1
              ? "Self Funded"
              : item?.lending_partner;
          return {
            label: label,
            value: item?.lending_partner,
          };
        });

        setOptions(options);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // ---------------------- Select and select 1 st Landing Partner -----------------------------
  const selectFirstLandingPartner = (item) => {
    if (partner1) {
      const updatedArray = dataArray.map((obj) => {
        if (obj?.order_id === item?.order_id) {
          return { ...obj, first_partner: partner1 };
        }
        return obj;
      });
      if (updatedArray?.length > 0) {
        setDataArray(updatedArray);
      }
    }
  };
  const handleSelect = (event, item) => {
    setPartner1(event.target.value);
    if (event.target.value) {
      const updatedArray = dataArray.map((obj) => {
        if (obj?.order_id === item?.order_id) {
          return {
            ...obj,
            first_partner: event.target.value,
            lending_partner_1_product: "",
            // lending_partner_is_edited: true,
          };
        }
        return obj;
      });
      if (updatedArray?.length > 0) {
        setDataArray(updatedArray);
      }
    }
  };

  //------------------------------Get Landing Partner 1 - Products-------------------------

  useEffect(() => {
    if (partner1) {
      axios
        .get(`/api/partners/products?page=1&limit=100&partner_name=${partner1}`)
        .then((response) => {
          const temp = [];

          {
            response?.data?.products?.rows?.map((item, index) =>
              temp.push(item?.product_name)
            );
          }

          setProduct1(temp);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [partner1]);

  const handleSelectproduct = (event, item) => {
    setProduct1Name(event.target.value);
    const updatedArray = dataArray.map((obj) => {
      if (event.target.value) {
        if (obj.order_id === item?.order_id) {
          return { ...obj, lending_partner_1_product: event.target.value };
        }
        return obj;
      }
    });
    setDataArray([...updatedArray]);
  };
  const handleSelect2 = (event, item) => {
    setPartner2(event.target.value);
    const updatedArray = dataArray.map((obj) => {
      if (event.target.value) {
        if (obj.order_id === item?.order_id) {
          return {
            ...obj,
            second_partner: event.target.value,
            lending_partner_2_product: "",
          };
        }
        return obj;
      }
    });
    setDataArray([...updatedArray]);
  };

  //------------------------------Get Landing Partner 1 - Products-------------------------
  useEffect(() => {
    if (partner2) {
      axios
        .get(`/api/partners/products?page=1&limit=100&partner_name=${partner2}`)
        .then((response) => {
          const temp = [];

          {
            response?.data?.products?.rows?.map((item, index) =>
              temp.push(item?.product_name)
            );
          }

          setProduct2(temp);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [partner2]);

  const handleSelectproduct2 = (event, item) => {
    setProduct2Name(event.target.value);
    const updatedArray = dataArray.map((obj) => {
      if (obj.order_id === item?.order_id) {
        return { ...obj, lending_partner_2_product: "" };
      }
      return obj;
    });
    setDataArray([...updatedArray]);
  };
  //------------------------------- Landing partner -2 amt -----------------------
  const onChangeHandlerForLP1Amt = (e, item, index) => {
    const updatedArray = dataArray.map((obj) => {
      if (obj.order_id === item?.order_id) {
        const sum = item?.first_partner_amount + item?.second_partner_amount;
        return { ...obj, first_partner_amount: e.target.value };
      }
      return obj;
    });
    setDataArray([...updatedArray]);
  };
  //------------------------------- Landing partner -2 amt -----------------------
  const onChangeHandlerForLP2Amt = (e, item, index) => {
    const updatedArray = dataArray.map((obj) => {
      if (obj.order_id === item?.order_id) {
        if (obj?.second_partner) {
          return { ...obj, second_partner_amount: e.target.value };
        }
      }
      return obj;
    });
    setDataArray([...updatedArray]);
  };

  //  Get Lending Partners Card Data

  useEffect(() => {
    axios
      .get(`/workflow/lending_partner_limits`)
      .then((response) => {
        setLendingPartnerCardsData(response?.data?.lending_partner_limits[0]);
        console.log(
          response?.data?.lending_partner_limits[0],
          "------------------------- lpc -----------------------------"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const [lp, setlp] = useState();
  const res = [];
  const [newObj, setNewObj] = useState([{ key: "", array: [] }]);
  useEffect(() => {
    dataArray?.map((item, index) => {
      axios
        .get(
          `/api/partners/products?page=1&limit=100&partner_name=${item?.first_partner}`
        )
        .then((response) => {
          const temp = [];

          {
            response?.data?.products?.rows?.map((item, index) =>
              temp.push(item?.product_name)
            );
          }
          setNewObj([...newObj, { key: index, array: [...temp] }]);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }, [dataArray]);

  // GET Borrower Type
  const [selectedOrder, setSelectedOrder] = useState();
  const handleBorrowerChange = (e, item) => {
    setSelectedOrder(item);
    const dd = loadingData.filter((obj) => {
      return obj?.order_id === item?.order_id ? obj : "";
    });
    const payload = {
      buyer_id: dd[0]?.user_id,
      seller_id: dd[0]?.supplier_user_id,
      actioner_name: userDetails?.user_name,
      actioner_id: userDetails?.id,
      total_cp: dd[0]?.total_cp_cal,
      borrower: e,
    };

    axios
      .post(`/v1/fund_management/limit_assing_to_merchant`, payload)
      .then((response) => {
        console.log(response?.data);
        if (response?.data?.status) {
          setAutoFund(response?.data);
          autoFundOpenHandler();
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ---------------------------------- confirmation to add partner -----------------------------------

  const addPartner = () => {
    autoFundCloseHandler();
    const data = dataArray.map((item) => {
      if (item.order_id === selectedOrder?.order_id) {
        console.log(
          autoFund?.payload?.lending_partner_name,
          "In IFFFFFFFFFFFf"
        );
        return {
          ...item,
          first_partner: autoFund?.payload?.lending_partner_name,
          lending_partner_is_edited: false,
        };
      } else {
        return { ...item, lending_partner_is_edited: true };
      }
    });
    setDataArray([...data]);
  };
  const noPartner = () => {
    autoFundCloseHandler();
    const data = dataArray.map((item) => {
      if (item.order_id === selectedOrder?.order_id) {
        console.log(
          autoFund?.payload?.lending_partner_name,
          "In IFFFFFFFFFFFf"
        );
        return {
          ...item,
          lending_partner_is_edited: true,
        };
      }
      return item;
    });
    setDataArray([...data]);
  };

  const getWorkTypesData = async () => {
    try {
      const data = await fetchData(
        "/workflow-api/get_order_elements?dropdown_type=Work Type&start=0&length=1027"
      );
      console.log("Fetched data:", data);
      if (data?.data?.length > 0) {
        setWorkTypes(data?.data);
      } else {
        setWorkTypes([]);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const getTransactionTypesData = async () => {
    try {
      const data = await fetchData(
        "/workflow-api/get_order_elements?dropdown_type=Transaction Type&start=0&length=1027"
      ); // replace with your actual endpoint
      console.log("Fetched data:", data);
      if (data?.data?.length > 0) {
        setTransactionTypes(data?.data);
      } else {
        setTransactionTypes([]);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const getSupplierTransactionTypesData = async () => {
    try {
      const data = await fetchData(
        "/workflow-api/get_order_elements?dropdown_type=Supplier Transaction Type&start=0&length=1027"
      );
      if (data?.data?.length > 0) {
        setSupplierTransactionTypes(data?.data);
      } else {
        setSupplierTransactionTypes([]);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const handleBulkExcelUpload = async () => {
    if (!bulkUploadFile) {
      toast.error("Please select an Excel file first.");
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in again.");
      return;
    }
    setBulkUploadLoading(true);
    const formData = new FormData();
    formData.append("file", bulkUploadFile);
    try {
      const { data } = await axios.post(FNV_BULK_GRID_API, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setBulkUploadLoading(false);
      setBulkUploadFile(null);
      if (bulkFileInputRef.current) bulkFileInputRef.current.value = "";
      if (data?.status !== false && !data?.message?.toLowerCase?.().includes("error")) {
        const failedResponse = data?.failed_response ?? data?.data?.failed_response;
        const hasFailedResponse = Array.isArray(failedResponse) && failedResponse.length > 0;

        // Add grids to table ONLY when failed_response is empty or absent
        if (!hasFailedResponse) {
          const grids = data?.grids ?? data?.data?.grids ?? [];
          if (Array.isArray(grids) && grids.length > 0) {
            const prev = dataArrayRef.current;
            const existingIds = new Set(prev.map((item) => Number(item?.order_id)));
            const toAdd = grids
              .filter((g) => g && !existingIds.has(Number(g?.order_id)))
              .map((resultObj) => ({
                ...resultObj,
                total_payable: resultObj?.total_cp ?? resultObj?.total_payable,
                first_partner: resultObj?.first_partner,
                total_payable_net_off_tds:
                  resultObj?.total_cp ?? resultObj?.total_payable_net_off_tds,
                work_type: resultObj?.work_type,
                transaction_type: resultObj?.transaction_type,
                transaction_type_supplier_payment:
                  resultObj?.transaction_type_supplier_payment,
                tds: resultObj?.tds ?? resultObj?.tds,
              }));
            const addedCount = toAdd.length;
            const skippedCount = grids.length - addedCount;
            if (addedCount > 0) {
              setDataArray((prevArr) => [...prevArr, ...toAdd]);
              setDataArrayTocheck((prevTocheck) => [...prevTocheck, ...toAdd.map((item) => ({ ...item }))]);
              toast.success(
                `${addedCount} order(s) added to grid.${skippedCount > 0 ? ` ${skippedCount} already in grid.` : ""}`
              );
            } else if (skippedCount > 0) {
              toast.success("All orders from file were already in the grid.");
            }
          } else {
            toast.success(data?.message || "Bulk upload completed successfully.");
          }
        } else {
          setFailedResponseList(failedResponse);
          setOpenFailedResponseModal(true);
          toast.error("Some orders could not be added. No orders have been added to the grid.");
        }
        setOpenBulkUploadModal(false);
      } else {
        toast.error(data?.message || "Bulk upload failed.");
      }
    } catch (err) {
      setBulkUploadLoading(false);
      const msg = err?.response?.data?.message || err?.message || "Bulk upload failed.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    getWorkTypesData();
    getTransactionTypesData();
    getSupplierTransactionTypesData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-2 px-0 ">
        <Loader loading={loading} />
        <div className="container-fluid mt-3">
          <LendingPartnerScroller
            lendingPartnersCardsData={lendingPartnersCardsData}
          />
        </div>

        <div className="container-fluid mt-2 d-flex justify-content-between px-0 align-items-center">
          <div className="row mx-0">
            <div className="col-12 text-start" style={{ fontWeight: 500 }}>
              <span className="fs-5 text-dark">
                Ayekart Agro / <span className="text-dark">FNV Orders</span>
              </span>
            </div>
          </div>
          {/* ==========Upload in Bulk + Download sample========== */}
          <div className="d-flex align-items-center gap-1">
            <Button
              variant="contained"
              style={{ backgroundColor: "#172554", color: "#fff" }}
              onClick={() => setOpenBulkUploadModal(true)}
              disabled={restrictedUser()}
            >
              Upload in Bulk
            </Button>
            <Tooltip title="Download sample file">
              <IconButton
                component="a"
                href="https://ayekart-mobile.sfo2.digitaloceanspaces.com/bulk_grid_sample_download.xlsx"
                download
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                size="small"
                aria-label="Download sample file"
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          </div>

          <form onSubmit={handleSubmit(handleCheckAndAddOrder)}>
            <div className="row mx-0 mt-2">
              <div className="col-md-auto">
                <div className="input-group mb-3">
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    style={{ border: "1px solid #5863b4" }}
                    className={classnames("form-control", {
                      "is-invalid": errors?.order_id,
                    })}
                    {...register("order_id", {
                      required: "Order ID is required",
                    })}
                    name="order_id"
                    placeholder="Enter Order ID"
                    aria-label="Order ID"
                    aria-describedby="button-addon2"
                  />
                  <button
                    type="submit"
                    className="btn btn-outline-secondary border-2"
                    style={{
                      backgroundColor: "#172554",
                      color: "#fff",
                    }}
                    id="button-addon2"
                  >
                    <span>+ Add</span>
                  </button>
                </div>
              </div>
              <div className="col-md-auto">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-secondary w-100 px-4"
                  style={{
                    backgroundColor: "#172554",
                    color: "#fff",
                  }}
                  onClick={() => history("/ayekart-agro/fnv/grids")}
                >
                  <span className="">View Grids</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="container-fluid mt-1 pt-1">
          <div className="row mx-0">
            <div className="outer-wrapper px-0">
              <div className="table-wrapper-finance-grid bg-white">
                <table>
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="order-ID-sticky top-0 z-40 left-0"
                      >
                        Order ID
                      </th>
                      <th scope="col">Add To Grid</th>
                      <th scope="col">Ordered Date</th>
                      <th scope="col">Buyer Name</th>
                      <th scope="col">Seller Name</th>
                      <th scope="col">Sourcer Name</th>
                      <th scope="col">Work Type</th>
                      <th scope="col">Transaction Type</th>
                      <th scope="col">Supplier Transaction Type</th>
                      <th scope="col">Total SP</th>
                      <th scope="col">Total CP</th>
                      <th scope="col">Lending partner 1</th>
                      <th scope="col">Lending partner 1 Amount</th>
                      <th scope="col">Lending partner 2</th>
                      <th scope="col">Lending partner 2 Amount</th>
                      <th scope="col">Amount disbursed by lending partner</th>
                      <th scope="col">Amount paid to supplier</th>
                      <th scope="col">Advance paid by buyer</th>
                      <th scope="col">Amount transferred to NBFC</th>
                      <th scope="col">Repayment amount</th>
                      <th scope="col ">Balance Due Amount</th>
                      <th scope="col">Document sign merchant status</th>
                      <th scope="col">Payment Status</th>
                    </tr>
                  </thead>
                  <tbody className="textFonts">
                    {loadingData?.length > 0
                      ? loadingData?.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td className="sticky-column">
                                <h6>{data?.order_id}</h6>
                              </td>
                              <td>
                                {" "}
                                <button
                                  className="btn btn-secondary p-0 pl-3 pr-3"
                                  type=""
                                  onClick={() =>
                                    handleCheckAndAddOrderFromTable(
                                      data.order_id
                                    )
                                  }
                                >
                                  Add
                                </button>
                              </td>
                              <td>
                                {new Date(data?.created_at).getDate() +
                                  "-" +
                                  (new Date(data?.created_at).getMonth() + 1) +
                                  "-" +
                                  new Date(data?.created_at).getFullYear()}
                              </td>
                              <td className="text-break">{data?.buyer_name}</td>
                              <td>{data?.seller_name}</td>
                              <td>{data?.sourcer_name}</td>
                              <td>{data?.work_type || "NA"}</td>
                              <td>{data?.transaction_type || "NA"}</td>
                              <td>
                                {data?.transaction_type_supplier_payment ||
                                  "NA"}
                              </td>
                              <td>
                                ₹{" "}
                                {data?.total_sp
                                  ? Number(data.total_sp).toFixed(2)
                                  : Number(data.amount).toFixed(2)}
                              </td>
                              <td>
                                {data?.total_cp_cal
                                  ? `₹${Number(data.total_cp_cal).toFixed(2)}`
                                  : "--NA--"}
                              </td>
                              <td>
                                {data?.lending_partner
                                  ? data?.lending_partner
                                  : "--NA--"}
                              </td>
                              <td>
                                {Number(data.first_partner_amount).toFixed(2)
                                  ? Number(data.first_partner_amount).toFixed(2)
                                  : 0.0}
                              </td>
                              <td>
                                <div className="controls">
                                  {data.second_partner
                                    ? data.second_partner
                                    : "--NA--"}
                                </div>
                              </td>
                              <td>
                                {Number(data.second_partner_amount).toFixed(2)}
                              </td>
                              <td>
                                <div className="row mx-auto">
                                  <div className="d-flex flex-column mx-auto">
                                    {data.partner_disbursed_amount ? (
                                      <span>
                                        ₹{" "}
                                        {Number(
                                          data.partner_disbursed_amount
                                        ).toFixed(2)}
                                      </span>
                                    ) : (
                                      <span className="text-muted">--NA--</span>
                                    )}
                                    {data?.amount_disburse_date ? (
                                      <small className="text-muted">
                                        {new Date(
                                          data.amount_disburse_date
                                        ).getDate() +
                                          "-" +
                                          (new Date(
                                            data.amount_disburse_date
                                          ).getMonth() +
                                            1) +
                                          "-" +
                                          new Date(
                                            data.amount_disburse_date
                                          ).getFullYear()}
                                      </small>
                                    ) : (
                                      <span className="text-secondary">
                                        --NA--
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="">
                                <div
                                  className="innerScroll"
                                  style={{
                                    overflowY: "auto",
                                    maxHeight: "100px",
                                    overflowX: "hidden",
                                  }}
                                >
                                  {data?.supplier_transferred_data !== null ? (
                                    data?.supplier_transferred_data.map(
                                      (element, childIndex) => (
                                        <div
                                          className="row"
                                          style={{ marginBottom: 15 }}
                                          key={childIndex}
                                        >
                                          <div className="pl-3">
                                            <span>₹ {element?.amount}</span>
                                            <small className=" fw-bold text-secondary">
                                              {" Date : "}
                                              {new Date(
                                                element?.date
                                              ).getDate() +
                                                "-" +
                                                (new Date(
                                                  element?.date
                                                ).getMonth() +
                                                  1) +
                                                "-" +
                                                new Date(
                                                  element?.date
                                                ).getFullYear()}
                                            </small>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div>
                                      <span>--NA--</span>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="row">
                                  <div className="">
                                    {data.advance_paid_amount ? (
                                      <span>₹{data.advance_paid_amount}</span>
                                    ) : (
                                      <span className=" text-secondary">
                                        ₹--NA--
                                      </span>
                                    )}

                                    <small className="fw-bold text-secondary">
                                      {" Date : "}
                                    </small>
                                    {data?.advance_amount_collected_date ? (
                                      <small className=" text-secondary pr-1">
                                        {new Date(
                                          data.advance_amount_collected_date
                                        ).getDate() +
                                          "-" +
                                          (new Date(
                                            data.advance_amount_collected_date
                                          ).getMonth() +
                                            1) +
                                          "-" +
                                          new Date(
                                            data.advance_amount_collected_date
                                          ).getFullYear()}
                                      </small>
                                    ) : (
                                      <span className="text-secondary mr-3">
                                        --NA--
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control h-25"
                                  disabled
                                  defaultValue={Number(
                                    data?.partner_transferred_amount
                                  ).toFixed(2)}
                                />
                                <input
                                  type="checkbox"
                                  disabled
                                  defaultChecked={
                                    data?.finance_nbfc_confirm_11_status !==
                                    "Pending"
                                  }
                                ></input>
                                <label>Is amount transferred?</label>
                              </td>
                              <td>
                                <div
                                  className="innerScroll"
                                  style={{
                                    overflowY: "auto",
                                    maxHeight: "100px",
                                    overflowX: "hidden",
                                    width: "250px",
                                  }}
                                >
                                  {data?.partial_payment_data !== null ? (
                                    data.partial_payment_data.map(
                                      (
                                        Repaymentelement,
                                        RepaymentchildIndex
                                      ) => (
                                        <div
                                          className="row"
                                          style={{ marginBottom: 15 }}
                                          key={RepaymentchildIndex}
                                        >
                                          <div className="pl-3">
                                            <span>
                                              ₹{" "}
                                              {Number(
                                                Repaymentelement?.amount
                                              ).toFixed(2)}
                                            </span>
                                            <small className="text-secondary">
                                              {" Date :"}
                                              {Repaymentelement?.date}
                                            </small>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div>
                                      <span>--NA--</span>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="row balance-due">
                                  <span>
                                    Total Paid: ₹{" "}
                                    {Number(data?.paid_amount).toFixed(2)}
                                  </span>
                                </div>
                                <div className="row balance-due">
                                  <span>
                                    Balance Due:₹{" "}
                                    {Number(data?.balance_due_amount).toFixed(
                                      2
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td>{data?.order_sign_doc_merchant_status}</td>
                              <td>
                                <div className="row mx-auto">
                                  <button className=" " disabled>
                                    {data?.collection_status}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row mx-0 mt-2">
            <div className="col-sm-6 d-flex justify-content-start">
              Showing {15 * currentPage - (15 - 1)} to {15 * currentPage}{" "}
              entries of {totalResults ? totalResults : ""}
            </div>
            <div className="col-sm-6 d-flex justify-content-end">
              <ul className="pagination">
                <li className="page-item pt-1 pl-2 pr-2 border">
                  <a
                    href="#overview-page"
                    className={currentPage !== pages[0] ? "show" : "hideBtn"}
                    onClick={(e) => handlePrevBtn(e)}
                  >
                    Prev
                  </a>
                </li>
                {renderPageNumbers}
                <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                  <a
                    href="#overview-page"
                    className={
                      currentPage !== pages.length ? "show" : "hideBtn"
                    }
                    onClick={(e) => handleNextBtn(e)}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="container-fluid text-center mt-0 py-3 border rounded shadow overflow-auto">
          <div className="overflow-auto">
            <div className="row mx-0 mb-2">
              <span className="text-start fs-4 fw-bolder">
                Orders to be added in Grid | Total Orders : {dataArray?.length}
              </span>
            </div>
            <TableContainer sx={{ maxHeight: 800 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead style={{ backgroundColor: "#adb2da" }}>
                  <TableRow
                    style={{ backgroundColor: "#172554", color: "#fff" }}
                  >
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Order ID</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Supplier Shop Name</h6>
                    </TableCell>
                    {/* Work Type */}
                    <TableCell
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Work Type</h6>
                    </TableCell>
                    {/* Transaction Type */}
                    <TableCell
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Transaction Type</h6>
                    </TableCell>
                    {/* Supplier Transaction Type */}
                    <TableCell
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Supplier Transaction Type</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Total CP(₹)</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Total payable(₹)</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Borrower type</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Lending partner 1</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6
                        className="fw-bolder"
                        style={{ backgroundColor: "#172554", color: "#fff" }}
                      >
                        Lending partner 1 - Product
                      </h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Lending partner 1 Amount</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Lending partner 2</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Lending partner 2 - Product</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">Lending partner 2 Amount</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">TDS(₹)</h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    >
                      <h6 className="fw-bolder">
                        Amount To Be Paid Net Off TDS(₹)
                      </h6>
                    </TableCell>
                    <TableCell
                      align=""
                      style={{ backgroundColor: "#172554", color: "#fff" }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataArray?.length > 0 ? (
                    dataArray?.map((item, index) => (
                      <React.Fragment key={index}>
                        <TableRow
                          hover
                          role="checkbox"
                          className="mt-4"
                          style={{
                            backgroundColor: "#d7daf9",
                            border: "1px solid #fff",
                          }}
                        >
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            {item?.order_id}
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            {item?.supplier_shop_name}
                          </TableCell>
                          {/* Work Type */}
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <FormControl
                              fullWidth
                              size="small"
                              className="fw-bolder"
                            >
                              <InputLabel
                                id={`work-type-select-label-${index}`}
                              >
                                Work Type
                              </InputLabel>
                              <Select
                                labelId={`work-type-select-label-${index}`}
                                id={`work-type-select-${index}`}
                                value={item?.work_type || ""}
                                onChange={(e) => {
                                  const updatedArray = dataArray.map(
                                    (obj, idx) => {
                                      if (idx === index) {
                                        return {
                                          ...obj,
                                          work_type: e.target.value,
                                        };
                                      }
                                      return obj;
                                    }
                                  );
                                  setDataArray(updatedArray);
                                }}
                              >
                                {workTypes?.map((workType, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={workType?.dropdown_value}
                                  >
                                    {workType?.dropdown_value}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>

                          {/* Transaction Type */}
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <FormControl
                              fullWidth
                              size="small"
                              className="fw-bolder"
                            >
                              <InputLabel
                                id={`transaction-type-select-label-${index}`}
                              >
                                Transaction Type
                              </InputLabel>
                              <Select
                                labelId={`transaction-type-select-label-${index}`}
                                id={`transaction-type-select-${index}`}
                                value={item?.transaction_type || ""}
                                onChange={(e) => {
                                  const updatedArray = dataArray.map(
                                    (obj, idx) => {
                                      if (idx === index) {
                                        return {
                                          ...obj,
                                          transaction_type: e.target.value,
                                        };
                                      }
                                      return obj;
                                    }
                                  );
                                  setDataArray(updatedArray);
                                }}
                              >
                                {transactionTypes?.map(
                                  (transactionType, idx) => (
                                    <MenuItem
                                      key={idx}
                                      value={transactionType?.dropdown_value}
                                    >
                                      {transactionType?.dropdown_value}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </TableCell>
                          {/* Supplier Transaction Type */}
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <FormControl
                              fullWidth
                              size="small"
                              className="fw-bolder"
                            >
                              <InputLabel
                                id={`supplier-transaction-type-select-label-${index}`}
                              >
                                Supplier Transaction Type
                              </InputLabel>
                              <Select
                                labelId={`supplier-transaction-type-select-label-${index}`}
                                id={`supplier-transaction-type-select-${index}`}
                                value={
                                  item?.transaction_type_supplier_payment || ""
                                }
                                onChange={(e) => {
                                  const updatedArray = dataArray.map(
                                    (obj, idx) => {
                                      if (idx === index) {
                                        return {
                                          ...obj,
                                          transaction_type_supplier_payment:
                                            e.target.value,
                                        };
                                      }
                                      return obj;
                                    }
                                  );
                                  setDataArray(updatedArray);
                                }}
                              >
                                {supplierTransactionTypes?.map(
                                  (supplierTransactionType, idx) => (
                                    <MenuItem
                                      key={idx}
                                      value={
                                        supplierTransactionType?.dropdown_value
                                      }
                                    >
                                      {supplierTransactionType?.dropdown_value}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              readOnly
                              className="form-control"
                              type="number" onWheel={(e) => e.target.blur()}
                              name=""
                              value={Number(item?.total_cp)?.toFixed(3)}
                              placeholder="Total Cp"
                            />
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              className="form-control"
                              type="number" onWheel={(e) => e.target.blur()}
                              name=""
                              defaultValue={Number(item?.total_payable)}
                              placeholder="Total payable"
                              onChange={(e) =>
                                totalPayableHandler(e, item, index)
                              }
                            />
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <FormControl
                              fullWidth
                              size="small"
                              className="fw-bolder"
                            >
                              <InputLabel id="demo-simple-select-label">
                                Borrower
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                // value={age}
                                label="Age"
                                onChange={(e) =>
                                  handleBorrowerChange(e.target.value, item)
                                }
                              >
                                <MenuItem value="buyer">Buyer</MenuItem>
                                <MenuItem value="supplier">Supplier</MenuItem>
                              </Select>
                            </FormControl>
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Select"
                                onChange={(e) => handleSelect(e, item)}
                                value={item?.first_partner}
                              >
                                {options?.map((item) => (
                                  <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            {item?.first_partner ? (
                              item?.lending_partner_1_product ? (
                                item?.lending_partner_1_product
                              ) : (
                                <>
                                  <Button
                                    disabled={
                                      item?.first_partner ? false : true
                                    }
                                    variant="contained"
                                    onClick={() => {
                                      setOpenProduct1(true);
                                      setSingleData(item);
                                    }}
                                  >
                                    Add Product
                                  </Button>
                                </>
                              )
                            ) : (
                              "Lending partner 1 not assigned yet"
                            )}
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              className="form-control"
                              type="number" onWheel={(e) => e.target.blur()}
                              defaultValue={Number(item?.first_partner_amount)}
                              onChange={(e) =>
                                onChangeHandlerForLP1Amt(e, item, index)
                              }
                              placeholder="Total Amount"
                            />
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Select"
                              onChange={(e) => handleSelect2(e, item)}
                              value={item?.second_partner}
                            >
                              {options?.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            {item?.second_partner ? (
                              item?.lending_partner_2_product ? (
                                item?.lending_partner_2_product
                              ) : (
                                <>
                                  <Button
                                    disabled={
                                      item?.second_partner ? false : true
                                    }
                                    variant="contained"
                                    onClick={() => {
                                      setOpenProduct2(true);
                                      setSingleData(item);
                                    }}
                                  >
                                    Add Product
                                  </Button>
                                </>
                              )
                            ) : (
                              "Lending partner 2 not assigned yet"
                            )}
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              className="form-control"
                              type="number" onWheel={(e) => e.target.blur()}
                              disabled={item?.second_partner ? false : true}
                              defaultValue={Number(item?.second_partner_amount)}
                              onChange={(e) =>
                                onChangeHandlerForLP2Amt(e, item, index)
                              }
                              placeholder="Total Amount"
                            />
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              className="form-control"
                              type="number" onWheel={(e) => e.target.blur()}
                              value={item?.tds}
                              onChange={(e) => onchangeForTDS(e, item, index)}
                            />
                          </TableCell>

                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <input
                              readOnly
                              className="form-control"
                              type="text"
                              name=""
                              value={
                                item?.tds === 0
                                  ? Number(item?.total_payable).toFixed(2)
                                  : Number(
                                      item?.amount_to_be_paid_net_off_tds
                                    ).toFixed(2)
                              }
                              placeholder="Total Amount"
                            />
                          </TableCell>
                          <TableCell style={{ backgroundColor: "#fff" }}>
                            <span className="ml-1 ">
                              <i
                                className="fa fa-trash text-secondary fs-3 mt-2 "
                                role="button"
                                onClick={() => removeFromDataArray(index)}
                              ></i>
                            </span>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  ) : (
                    <div className="d-flex justify-content-center">
                      <div className="row finance-grid-tbody-no-data">
                        <p>No Data Added</p>
                      </div>
                    </div>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

        <div className="container-fluid text-center mt-2 mb-3">
          <div className="row justify-content-md-center">
            <div className="col d-flex justify-content-between px-0">
              <TextField
                className="bg-light"
                multiline
                fullWidth
                minRows={1}
                maxRows={4}
                placeholder="Write a comment..."
                value={gridComment}
                onChange={(e) => setGridComment(e.target.value)}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={submitGrids}
                        disabled={restrictedUser()}
                        edge="end"
                        color="primary"
                      >
                        <SendIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </div>

        <AddProduct1
          openProduct1={openProduct1}
          closehandleProduct1={closehandleProduct1}
          singleData={singleData}
          dataArray={dataArray}
          setDataArray={setDataArray}
        />
        <AddProduct2
          openProduct2={openProduct2}
          closehandleProduct2={closehandleProduct2}
          singleData={singleData}
          dataArray={dataArray}
          setDataArray={setDataArray}
        />
        <Toaster />
      </div>

      <Modal
        open={openBulkUploadModal}
        onClose={closeBulkUploadModal}
        aria-labelledby="bulk-upload-modal-title"
        aria-describedby="bulk-upload-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="bulk-upload-modal-title"
            variant="h6"
            component="h2"
            className="fw-bolder"
          >
            Upload in Bulk
          </Typography>
          <hr
            style={{
              height: "3px",
              background: "#0C3094",
              opacity: "0.65",
            }}
          />
          <div className="mt-3">
            <input
              ref={bulkFileInputRef}
              type="file"
              accept=".xlsx,.xls"
              className="d-none"
              onChange={(e) => setBulkUploadFile(e.target.files?.[0] || null)}
            />
            <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
              <Button
                variant="outlined"
                onClick={() => bulkFileInputRef.current?.click()}
                disabled={bulkUploadLoading}
              >
                Choose Excel
              </Button>
              {bulkUploadFile && (
                <Typography variant="body2" color="text.secondary">
                  {bulkUploadFile.name}
                </Typography>
              )}
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="outlined"
                onClick={closeBulkUploadModal}
                disabled={bulkUploadLoading}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{ backgroundColor: "#172554" ,color:"#fff"}}
                onClick={handleBulkExcelUpload}
                disabled={!bulkUploadFile || bulkUploadLoading}
              >
                {bulkUploadLoading ? "Uploading…" : "Upload"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openFailedResponseModal}
        onClose={() => setOpenFailedResponseModal(false)}
        aria-labelledby="failed-response-modal-title"
        aria-describedby="failed-response-modal-description"
      >
        <Box sx={{...modalStyle, width: 750,borderTop: "7px solid red",}}>
          <Typography
            id="failed-response-modal-title"
            variant="h6"
            component="h2"
            className="fw-bolder text-danger text-capitalize"
          >
            Bulk upload – failed orders
          </Typography>
          <hr
            style={{
              height: "3px",
              background: "#0C3094",
              opacity: "0.65",
            }}
          />
          <div id="failed-response-modal-description" className="mt-3">
            <Typography variant="body2" color="text.secondary" className="mb-2">
              The following order(s) could not be added to the grid:
            </Typography>
            <TableContainer sx={{ maxHeight: 320 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, color: "red",bgcolor:"#FBD5D5" }}>Order ID</TableCell>
                    <TableCell sx={{ fontWeight: 600, color: "red",bgcolor:"#FBD5D5" }}>Reason</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {failedResponseList.map((item, index) => (
                    <TableRow key={item?.order_id ?? index}>
                      <TableCell>{item?.order_id ?? "—"}</TableCell>
                      <TableCell>{item?.reason ?? "—"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="d-flex justify-content-end mt-3">
              <Button
                variant="contained"
                style={{ backgroundColor: "#172554" ,color:"#fff"}}
                onClick={() => setOpenFailedResponseModal(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={autoFundModel}
        onClose={autoFundCloseHandler}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="fw-bolder"
          >
            {`${autoFund?.message} , You want to add this partner ?`}
          </Typography>
          {console.log(autoFund)}
          <hr
            style={{
              height: "3px",
              background: "#0C3094",
              opacity: "0.65",
            }}
          ></hr>
          <div className="d-flex justify-end gap-3 mt-2">
            <Button
              variant="contained"
              style={{ backgroundColor: "#161721" }}
              onClick={() => {
                addPartner();
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#99243D" }}
              onClick={() => noPartner()}
            >
              No
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default AyekartAgroFNVOrders;
